import {BasicService} from './basic.service';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_COMPANY_URL } from '../../connection.data';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CompanyService extends BasicService {

    private currentCompany: any = {id: -1, name: ""};
    public companyLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_COMPANY_URL;
        this.currentCompany = JSON.parse(localStorage.getItem(environment.company));
        if(this.currentCompany){
            //console.log("constructor company loaded: ");console.dir(this.currentCompany);
            this.companyLoaded$.next(true);
        }
    }
    setCurrentCompany(company){
        this.currentCompany = company;
        localStorage.setItem(environment.company, JSON.stringify(this.currentCompany));
        if(this.currentCompany){
            //console.log("set company loaded: ");console.dir(this.currentCompany);
            this.companyLoaded$.next(true);
        }
    }
    getCurrentCompany(){
        return this.currentCompany;
    }
}
